module.exports = __webpack_public_path__ + "static/media/白露.cfc28f5b.png";